// extracted by mini-css-extract-plugin
module.exports = {"ContentBlock":"ContentBlock_ContentBlock__1NvVU","ContentBlock__label":"ContentBlock_ContentBlock__label__9bwym"};